<template>
    <div class="video_loading" :class="{first_time: first_time, fade_out: fade_out}">
        <div class="iframe-view">
            <!--        verify if is video or image-->
            <div v-if="isVideo">
                <video ref="video" :src="video_loading" style="width: 100%; height: 100%;"></video>
            </div>
            <div v-else>
                <img  :src="video_loading" style="width: 100%; height: 100%;" alt="image">
            </div>
            <div v-if="canClose" class="close_video" @click="closeVideo">
                {{ $t('video_loading.skip') }}
                <span class="material-symbols-outlined">arrow_forward_ios</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "VideoLoadingUnity",
    computed: {
        // video_loading is url
        cookie_name() {
            const id = this.$store.getters["current_session"].id;
            const lang = this.$i18n.locale
            return `video_loading_${id}_${lang}`;
        },
        video_loading() {
            return this.$store.getters["current_session"].video_loading;
        },
        isVideo() {
            return this.video_loading.includes(".mp4") || this.video_loading.includes(".webm") || this.video_loading.includes(".ogg");
        },
    },
    data() {
        return {
            first_time:false,
            canClose:false,
            fade_out:false
        }
    },
    mounted() {
        // onvideo load if not can play show modal
        this.$refs.video.addEventListener('loadeddata', async () => {
                try {
                    await this.playVideo();
                } catch (e) {
                    this.$app.addTranslucentModal({
                        size: 'sm',
                        title: this.$t('translucent_modal.video_room.title'),
                        content: this.$t('translucent_modal.video_room.content'),
                        confirm_text: this.$t('translucent_modal.video_room.confirm'),
                        can_cancel: false,
                        can_close: false,
                        close_background: true,
                        background:true,
                        callback: () => {
                            this.playVideo()
                        },
                        callback_close: () => {
                            this.playVideo()
                        },
                    });
                }
        });
        this.$refs.video.addEventListener('ended', () => {
            this.canClose = true;
            // this.closeVideo();
        });
        if (!this.$app.getCookie(this.cookie_name)){
            this.$app.setCookie(this.cookie_name, true);
            this.first_time = true;
        }
    },
    methods:{
        closeVideo(){
            this.$app.sendToUnity('VideoLoadingEnded');
            this.fade_out = true;
            setTimeout(() => {
                this.$app.video_loading_show = false;
            }, 500);
        },
        async playVideo(){
            if (this.$refs.video) {
                await this.$refs.video.play();
                if (!this.first_time){
                    this.canClose = true;
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.video_loading{
    position: fixed;
    width: 100%;
    height: 100%;
    background: #000;
    top: 0;
    left: 0;
}
.fade_out{
    .iframe-view{
        animation: fadeOut 0.5s;
    }
}
@keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
.iframe-view {
    height: calc(100vh - var(--headers_height));
    margin-top: var(--headers_height);
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    video, img {
        pointer-events: none;
    }
    .close_video{
        position: absolute;
        right: 15px;
        bottom: 15px;
        background-color: rgba(0,0,0,0.7);
        backdrop-filter: blur(5px);
        color: white;
        font-size: 1rem;
        font-family: Exo, sans-serif;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
        line-height: 1.75;
        border-radius: 30px;
        padding: 10px 30px;
        cursor: pointer;
        pointer-events: all;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        &:hover{
            background-color: rgba(50,50,50,0.7);
        }
    }
}
.material-symbols-outlined {
    font-family: 'Material Icons',serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1;
    color: white;

    font-variation-settings:
        'FILL' 1,
        'wght' 400,
        'GRAD' 0,
        'opsz' 24;
}

.iframe-view{
    transition: all 0.3s ease;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 37px;
    video, img {
        transition: all 0.3s ease;
    }
    .close_video{
        transition: all 0.3s ease;
        bottom: 45px;
    }
}
@media only screen and (max-width: 600px) {
    .iframe-view{
        height: auto;
        margin-top: 30px;
        max-width: 90%;
        max-width: 90vw;
        max-width: 1000px;
        padding: 0 20px;
        .close_video{
            bottom: -55px;
        }
    }
}
</style>